export const getHelperTextStyles = ({ error }) => ({
  position: 'absolute',
  width: '100%',
  top: '100%',
  padding: '5px 5px 0',
  margin: 0,
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  color: ({ palette }) => `${palette.text[error ? 'error' : 'secondary']} !important`,
});
